import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-chevron-down';
/**
 * Exported with its 24px frame, so `size` scales the frame. `chevron` is the bare vector its
 * existing callers are sized around, and consolidating the two is sc-530900.
 */
export const ChevronDownIcon = ({ fill = 'black', size = 'xsmall', className }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill, className);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            data-testid={TESTID}
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.29289 8.29287C5.68342 7.90237 6.31658 7.90237 6.70711 8.29287L12 13.5858L17.2929 8.29287C17.6834 7.90237 18.3166 7.90237 18.7071 8.29287C19.0976 8.68337 19.0976 9.31657 18.7071 9.70707L12.7071 15.7071C12.3166 16.0976 11.6834 16.0976 11.2929 15.7071L5.29289 9.70707C4.90237 9.31657 4.90237 8.68337 5.29289 8.29287Z"
            />
        </svg>
    );
};
ChevronDownIcon.TEST_ID = TESTID;
